// For each view you need to create a function to add it to the state provider
function initClntStates($stateProvider) {

	$stateProvider.state('home.clientCreate', {
		url : '/client/create',
		templateUrl : "views/clnt/client.detail.html",
		data : {
			type : 'create',
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.clientList', {
		url : "/client/list",
		templateUrl : "views/clnt/client.list.html",
		data : {
			type : 'search',
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code]
			}
		}
	}).state('home.clientUpdate', {
		url : '/client/:id',
		templateUrl : "views/clnt/client.detail.html",
		data : {
			type : 'update',
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.clientHome', {
		url : '/client/:id/home',
		templateUrl : "views/clnt/client.home.html",
		controller: "clientHomeCtrl",
		resolve:{
			clientHomeDataResolve: function($stateParams, clientService){
				return clientService.getHomeClient($stateParams.id);
			}
		},
		data : {
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.clientContacts', {
		url : '/client/:idClient/contact',
		templateUrl : "views/clnt/client.contact.list.html",
		data : {
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.contactCreate', {
		url : '/client/:idClient/contact/create',
		templateUrl : "views/clnt/client.contact.detail.html",
		data : {
			type : 'create',
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.contactUpdate', {
		url : '/client/:idClient/contact/:idContact/update',
		templateUrl : "views/clnt/client.contact.detail.html",
		data : {
			type : 'update',
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.clientSites', {
		url : '/client/:idClient/sites',
		templateUrl : "views/clnt/client.site.list.html",
		data : {
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.siteCreate', {
		url : '/client/:idClient/site/create',
		templateUrl : "views/clnt/client.site.detail.html",
		data : {
			type : 'create',
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.siteUpdate', {
		url : '/client/:idClient/site/:idSite/update',
		templateUrl : "views/clnt/client.site.detail.html",
		data : {
			type : 'update',
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.clientAreas', {
		url : '/client/:idClient/site/:idSite/area',
		templateUrl : "views/clnt/client.area.list.html",
		data : {
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.areaCreate', {
		url : '/client/:idClient/site/:idSite/area/create',
		templateUrl : "views/clnt/client.area.detail.html",
		data : {
			type : 'create',
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	}).state('home.areapUpdate', {
		url : '/client/:idClient/site/:idSite/area/:idArea/update',
		templateUrl : "views/clnt/client.area.detail.html",
		data : {
			type : 'update',
			permissions : {
				only : [ ROLE_TYPE.ADMIN.code ]
			}
		}
	});

}
